import React, {useState} from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

const EditClientForm = (props) => {
  
  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const params = {
      first_name: formData.get("first_name"),
      last_name: formData.get("last_name"),
      dietary_restrictions: formData.get("dietary_restrictions"),
      languages: formData.get("languages"),
      comments: formData.get("comments"),
      new_client: formData.get("new_client"),
      end_date: formData.get("end_date"),
      cancelled_date: formData.get("cancelled_date"),
      interview_date: formData.get("interview_date"),
      date_of_birth: formData.get("date_of_birth"),
      address: formData.get("address"),
      city: formData.get("city"),
      postal_code: formData.get("postal_code"),
      phone_number: formData.get("phone_number"),
      email: formData.get("email"),
      start_date: formData.get("start_date"),
      last_visit: formData.get("last_visit"),
      employment: formData.get("employment"),
      social_services: formData.get("social_services"),
      child_tax_credit: formData.get("child_tax_credit"),
      support_maintenance: formData.get("support_maintenance"),
      ei_benefits: formData.get("ei_benefits"),
      wcb_benefits: formData.get("wcb_benefits"),
      pension: formData.get("pension"),
      room_and_board: formData.get("room_and_board"),
      rent: formData.get("rent"),
      mortgage: formData.get("mortgage"),
      property_insurance: formData.get("property_insurance"),
      property_taxes: formData.get("property_taxes"),
      strata: formData.get("strata"),
      laundry: formData.get("laundry"),
      hydro: formData.get("hydro"),
      gas: formData.get("gas"),
      phone: formData.get("phone"),
      cable: formData.get("cable"),
      internet: formData.get("internet"),
      medical: formData.get("medical"),
      car_payment: formData.get("car_payment"),
      car_insurance: formData.get("car_insurance"),
      other_income: formData.get("other_income"),
      other_expenses: formData.get("other_expenses"),
      admin_comment: formData.get("admin_comment"),
      release_signed: formData.get("release_signed"),
    };
    props.updateClient(props.id, params);
  };

  const [selectedNewClientBtn, setSelectedNewClientBtn] = useState(props.new_client.toString());

  const isNewClientSelected = (value) => selectedNewClientBtn === value;

  const handleNewClientClick = (event) =>
    setSelectedNewClientBtn(event.currentTarget.value);

  const [selectedReleaseSignedBtn, setSelectedReleaseSignedBtn] = useState(props.release_signed?.toString());

  const isReleaseSignedSelected = (value) => selectedReleaseSignedBtn === value;

  const handleReleaseSignedClick = (event) =>
    setSelectedReleaseSignedBtn(event.currentTarget.value);
  
  return (
    <>
      <Form className="form pb-5 d-flex" onSubmit={handleSubmit}>
        <div>
          <h3 className="text-center">Personal details</h3>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>First name</u></Form.Label>
            <Form.Control
              htmlFor="first_name"
              id="first_name"
              name="first_name"
              type="text"
              defaultValue={props.first_name}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Last name</u></Form.Label>
            <Form.Control
              htmlFor="last_name"
              id="last_name"
              name="last_name"
              type="text"
              defaultValue={props.last_name}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Dietary restrictions</u></Form.Label>
            <Form.Control
              htmlFor="dietary_restrictions"
              id="dietary_restrictions"
              name="dietary_restrictions"
              type="text"
              defaultValue={props.dietary_restrictions}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Languages</u></Form.Label>
            <Form.Control
              htmlFor="languages"
              id="languages"
              name="languages"
              type="text"
              defaultValue={props.languages}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Comments</u></Form.Label>
            <Form.Control
              htmlFor="comments"
              id="comments"
              name="comments"
              as="textarea"
              rows={3}
              defaultValue={props.comments}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Admin Comment</u></Form.Label>
            <Form.Control
              htmlFor="admin_comment"
              id="admin_comment"
              name="admin_comment"
              as="textarea"
              rows={3}
              defaultValue={props.admin_comment}
            />
          </Form.Group>

          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>New client</u></Form.Label>
            <Form.Check
              htmlFor="new_client"
              id="new_client"
              name="new_client"
              type="radio"
              label="Yes"
              value="true"
              checked={isNewClientSelected('true')}
              onChange={handleNewClientClick}
            />
              <Form.Check
                htmlFor="new_client"
                id="new_client"
                name="new_client"
                type="radio"
                label="No"
                value="false"
                checked={isNewClientSelected('false')}
                onChange={handleNewClientClick}
                />
          </Form.Group>

          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Release signed</u></Form.Label>
            <Form.Check
              htmlFor="release_signed"
              id="release_signed"
              name="release_signed"
              type="radio"
              label="Yes"
              value="true"
              checked={isReleaseSignedSelected('true')}
              onChange={handleReleaseSignedClick}
            />
              <Form.Check
                htmlFor="release_signed"
                id="release_signed"
                name="release_signed"
                type="radio"
                label="No"
                value="false"
                checked={isReleaseSignedSelected('false')}
                onChange={handleReleaseSignedClick}
                />
          </Form.Group>

          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Address</u></Form.Label>
            <Form.Control
              htmlFor="address"
              id="address"
              name="address"
              type="text"
              defaultValue={props.address}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>City</u></Form.Label>
            <Form.Control
              htmlFor="city"
              id="city"
              name="city"
              type="text"
              defaultValue={props.city}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Postal code</u></Form.Label>
            <Form.Control
              htmlFor="postal_code"
              id="postal_code"
              name="postal_code"
              type="text"
              defaultValue={props.postal_code}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Phone number</u></Form.Label>
            <Form.Control
              htmlFor="phone_number"
              id="phone_number"
              name="phone_number"
              type="text"
              defaultValue={props.phone_number}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Email</u></Form.Label>
            <Form.Control
              htmlFor="email"
              id="email"
              name="email"
              type="text"
              defaultValue={props.email}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Date of birth</u></Form.Label>
            <Form.Control
              htmlFor="date_of_birth"
              id="date_of_birth"
              name="date_of_birth"
              type="date"
              defaultValue={props.date_of_birth}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Last visit</u></Form.Label>
            <Form.Control
              htmlFor="last_visit"
              id="last_visit"
              name="last_visit"
              type="date"
              defaultValue={props.last_visit}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Interview date</u></Form.Label>
            <Form.Control
              htmlFor="interview_date"
              id="interview_date"
              name="interview_date"
              type="date"
              defaultValue={props.interview_date}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Start date</u></Form.Label>
            <Form.Control
              htmlFor="start_date"
              id="start_date"
              name="start_date"
              type="date"
              defaultValue={props.start_date}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Cancelled date</u></Form.Label>
            <Form.Control
              htmlFor="cancelled_date"
              id="cancelled_date"
              name="cancelled_date"
              type="date"
              defaultValue={props.cancelled_date}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>End date</u></Form.Label>
            <Form.Control
              htmlFor="end_date"
              id="end_date"
              name="end_date"
              type="date"
              defaultValue={props.end_date}
            />
          </Form.Group>
        </div>

        <div>
          <h3 className="text-center">Income</h3>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Employment</u></Form.Label>
            <Form.Control
              htmlFor="employment"
              id="employment"
              name="employment"
              type="number"
              defaultValue={props.employment}
              
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Social services</u></Form.Label>
            <Form.Control
              htmlFor="social_services"
              id="social_services"
              name="social_services"
              type="number"
              defaultValue={props.social_services}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Child tax credit</u></Form.Label>
            <Form.Control
              htmlFor="child_tax_credit"
              id="child_tax_credit"
              name="child_tax_credit"
              type="number"
              defaultValue={props.child_tax_credit}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Support maintenance</u></Form.Label>
            <Form.Control
              htmlFor="support_maintenance"
              id="support_maintenance"
              name="support_maintenance"
              type="number"
              defaultValue={props.support_maintenance}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>EI benefits</u></Form.Label>
            <Form.Control
              htmlFor="ei_benefits"
              id="ei_benefits"
              name="ei_benefits"
              type="number"
              defaultValue={props.ei_benefits}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>WCB benefits</u></Form.Label>
            <Form.Control
              htmlFor="wcb_benefits"
              id="wcb_benefits"
              name="wcb_benefits"
              type="number"
              defaultValue={props.wcb_benefits}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Pension</u></Form.Label>
            <Form.Control
              htmlFor="pension"
              id="pension"
              name="pension"
              type="number"
              defaultValue={props.pension}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Other income</u></Form.Label>
            <Form.Control
              htmlFor="other_income"
              id="other_income"
              name="other_income"
              type="number"
              defaultValue={props.other_income}
            />
          </Form.Group>
        </div>

        <div>
          <h3 className="text-center">Expenses</h3>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Room and board</u></Form.Label>
            <Form.Control
              htmlFor="room_and_board"
              id="room_and_board"
              name="room_and_board"
              type="number"
              defaultValue={props.room_and_board}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Rent</u></Form.Label>
            <Form.Control
              htmlFor="rent"
              id="rent"
              name="rent"
              type="number"
              defaultValue={props.rent}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Mortgage</u></Form.Label>
            <Form.Control
              htmlFor="mortgage"
              id="mortgage"
              name="mortgage"
              type="number"
              defaultValue={props.mortgage}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Property insurance</u></Form.Label>
            <Form.Control
              htmlFor="property_insurance"
              id="property_insurance"
              name="property_insurance"
              type="number"
              defaultValue={props.property_insurance}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Property taxes</u></Form.Label>
            <Form.Control
              htmlFor="property_taxes"
              id="property_taxes"
              name="property_taxes"
              type="number"
              defaultValue={props.property_taxes}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Strata</u></Form.Label>
            <Form.Control
              htmlFor="strata"
              id="strata"
              name="strata"
              type="number"
              defaultValue={props.strata}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Laundry</u></Form.Label>
            <Form.Control
              htmlFor="laundry"
              id="laundry"
              name="laundry"
              type="number"
              defaultValue={props.laundry}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Hydro</u></Form.Label>
            <Form.Control
              htmlFor="hydro"
              id="hydro"
              name="hydro"
              type="number"
              defaultValue={props.hydro}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Gas</u></Form.Label>
            <Form.Control
              htmlFor="gas"
              id="gas"
              name="gas"
              type="number"
              defaultValue={props.gas}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Phone</u></Form.Label>
            <Form.Control
              htmlFor="phone"
              id="phone"
              name="phone"
              type="number"
              defaultValue={props.phone}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Cable</u></Form.Label>
            <Form.Control
              htmlFor="cable"
              id="cable"
              name="cable"
              type="number"
              defaultValue={props.cable}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Internet</u></Form.Label>
            <Form.Control
              htmlFor="internet"
              id="internet"
              name="internet"
              type="number"
              defaultValue={props.internet}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Medical</u></Form.Label>
            <Form.Control
              htmlFor="medical"
              id="medical"
              name="medical"
              type="number"
              defaultValue={props.medical}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Car payment</u></Form.Label>
            <Form.Control
              htmlFor="car_payment"
              id="car_payment"
              name="car_payment"
              type="number"
              defaultValue={props.car_payment}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Car insurance</u></Form.Label>
            <Form.Control
              htmlFor="car_insurance"
              id="car_insurance"
              name="car_insurance"
              type="number"
              defaultValue={props.car_insurance}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Other expenses</u></Form.Label>
            <Form.Control
              htmlFor="other_expenses"
              id="other_expenses"
              name="other_expenses"
              type="number"
              defaultValue={props.other_expenses}
            />
          </Form.Group>

        </div>

        <Button
          variant="primary"
          className="position-fixed bottom-50 end-0 py-3 mb-3"
          type="submit"
        >
          Update Client
        </Button>
      </Form>
    </>
  );
}

export default EditClientForm